export enum TicketClaimedState {
  Claimed = 'claimed',
  Unclaimed = 'unclaimed',
}
